import React, { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FiZap, FiUsers, FiSend } from 'react-icons/fi';

gsap.registerPlugin(ScrollTrigger);

const FeaturesRow = () => {
    useEffect(() => {
        gsap.fromTo(".feature-card",
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.8, stagger: 0.2, scrollTrigger: { trigger: ".features-container", start: "top 85%" } }
        );
    }, []);

    const features = [
        { icon: <FiZap />, title: "Fast Response", desc: "We respond to all inquiries within 24 hours." },
        { icon: <FiUsers />, title: "Expert Team", desc: "Our team of experts delivers high-quality solutions." },
        { icon: <FiSend />, title: "End-to-End Solutions", desc: "From concept to deployment, we've got you covered." },
    ];

    return (
        <section className="features-container py-16 px-6 max-w-7xl mx-auto">
            <div className="grid md:grid-cols-3 gap-6">
                {features.map((item, index) => (
                    <div
                        key={index}
                        className="feature-card bg-[#111] p-8 rounded-2xl border border-white/5 hover:border-[#F2B135] transition-all duration-500 group flex items-start gap-6"
                    >
                        <div className="text-[#F2B135] text-4xl group-hover:scale-110 transition-transform duration-300">
                            {item.icon}
                        </div>
                        <div>
                            <h4 className="text-white font-bold text-xl mb-2">{item.title}</h4>
                            <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FeaturesRow;